module.exports = __webpack_public_path__ + "img/58.a51ae7f1.jpg";